<template>
  <div id="about-index">
    <header-section :subnav_show="false" :change_color="true"></header-section>
    <!-- ======= Hero Section ======= -->
    <div id="hero-about" data-aos="zoom-out" data-aos-delay="100"></div>

    <div class="location" data-aos="fade-up" data-aos-delay="100">
      <div class="w1200 clearfix">
        <div class="left-nav">
          <a href="/about" class="active" title="企业简介">企业简介</a>
          <a href="/history" title="发展历程">发展历程</a>
          <a href="/honor" title="荣誉资质">荣誉资质</a>
        </div>
      </div>
    </div>

    <div class="section-company bg-lightWhite text-align-center">
      <div class="clearfix">
        <div class="section-title mt-5">
          <h2>企业简介</h2>
          <p>二十年励精图治,铸就行业先锋</p>
        </div>
        <div class="w1200 div-txt-center padding-tb-30">
          <img src="@/static/img/about/company1.jpg" />
        </div>
        <div class="w1200 about-content padding-tb-30">
          <div class="div-txt-left">
            <!-- <p>
              &nbsp;&nbsp;&nbsp;&nbsp;河北科瑞达仪器科技股份有限公司成立于2006年,专注于水质在线分析仪器和水环保分析仪器，以及各种基于水分析的研发和工程项目运用，拥有自主知识产权。
            </p>

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;公司运用水质在线分析核心技术，厚积薄发。构建起感知层、应用层、集成层、网络层等一系列水质安全、环境监测、工业水处理、高效农业等应用技术板块，为电力、石化、冶金、制药、能源、交通、环境、科技农业、水安全、生命科学等涉水领域提供了强有力的技术支撑。
            </p>

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;公司目前注册资本4620万元，注册地在国家级高新技术开发区——石家庄高新技术开发区金石工业园区。企业连续多年被认定为“优秀高新技术企业”，并被被评为“创新型企业”。旗下拥有多家子公司从事专业的一线运营。股票简称：科瑞达，股票代码：832189。
            </p>

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;目前，公司凭借水质在线传感、数字化感知发送器、环境分析仪器、应用分析控制集成等核心技术，按照涉水行业门类形成专业化分类发展，为水厂、管线饮用水领域建立起水质安全在线监督网络，为水源地、江河湖泊、污染源监测提供连续监测的多种预警手段装备，为污水处理方向输出了一系列专业化的技术装备，在工业用水领域形成水质净化、药剂维护一系列节能减排应用系统集成，在医药、半导体、生命科学等领域提供高精尖的技术装备和集成化产品，为医源性污染源和水系安全建立起一系列的应用问题解决方案，为水产养殖、高效农业建立起一整套技术应用方案，为泳池和商业用水提供整套的运行管理系统集成，实现了基于核心技术之上的跨越式发展。
            </p>

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;在人才引进和持续发展方面建立起多元化的各种奖项、提成、持股激励方案，为人才与企业共同发展提供更加完善的薪资和激励机制，更加促进企业的快速发展；在研发、制造、质量、售后等方面有着雄厚的专业团队，与国内多家院校建立起多元化校企合作关系。目前，已与北京航空航天大学、天津南开大学、石家庄铁道大学、河北科技大学、河北师范大学等多所院校建立校企合作关系，使产、学、研相结合，使资源达到优化配置。同时，科瑞达公司也成为院校一线实习和人才培训基地。
            </p>

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;在传感器、仪器、自控集成等硬件制造方面运用现代先进制造手段拥有规模化的自动生产线，在质量品管方面规范执行ISO9001、ISO14001等体系认证，在行业中率先实现了对传感器、数字化感知发送器、现场处理模块、整机产品的智能化自动检测，成就产品制造的一致性、重复性、可靠性，以坚持不懈的追求领跑行业制造之先锋。公司自有知识产权70多项，其中发明技术7项，软著40项，已受理的发明技术5项目。
            </p>

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;科瑞达仪器以专业的态度和工匠精神一直努力前行，深入一线，满足客户应用需求，每年推出一大批具有行业先进水平的新产品，保障行业的领先性。
            </p>

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;愿与各类涉水行业同仁共同建设“碧水青山”，并为实现这一美好愿望而不懈努力。不忘初心，砥砺向前!
            </p> -->
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;
              科瑞达仪器科始创于上世纪八十年代，2006成立股份有限公司,专注过程水质在线分析和环保分析仪器、传感器，全部自研拥有自主知识产权。
            </p>

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;数十载励精图治、厚积薄发、匠心独具，拥有电子、电化学、光学、光电子、物理、自动控制、物联网、传感器等多维度专业群，形成水质分析仪器、集成装备、科学仪器等百余种产品，服务于电力、石化、煤化、冶金、新能源、液冷、半导体等高端制造，以及市政水务、环境保护、水质净化、海水淡化、污水处理、科技农业等领域，提供水质过程分析仪器和集成装备，建成面积50亩（建筑面积3.3万平方米）的独立式产业园区，是迄今国内大型过程水质分析仪器制造基地。
            </p>

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;
              注册资本4620万元（实有资产数亿元），国家级高新技术开发区注册企业，被认定为优秀高新技术创新型企业、瞪羚企业、小巨人企业。旗下多家子公司从事一线运营。上市企业简称：科瑞达仪器，股票代码：832189。
            </p>

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;
              随着仪器发展的深化，为获得发展的可持续性先后与西安交大、燕山大学、河北工大、天津南开大学、航空航天大学、铁道大学、河北科技大学、河北师范大学等多所院校以及研究所建立了产、学、研相结合校企合作关系，使资源达到优化配置。科瑞达仪器也成为一线院校实习和人才培训基地。
            </p>

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;
              在传感器、仪器、自控集成等硬件制造方面运用现代先进制造手段拥有规模化的自动生产线，在质量品管方面规范执行ISO9001、ISO14001等体系认证，在行业中率先实现了对传感器、数字化感知发送器、现场处理模块、整机产品的智能化自动检测，成就产品制造的一致性、重复性、可靠性，以坚持不懈的追求领跑行业制造之先锋。公司自有知识产权70多项，其中发明专利8项，软著40项，已受理的发明技术5项目
            </p>
          </div>
        </div>
        <div class="w1200">
          <img
            src="@/static/img/about/company2.jpg"
            style="height: 210px; padding: 0 8px" />
          <img
            src="@/static/img/about/company3.jpg"
            style="height: 210px; padding: 0 8px" />
          <img
            src="@/static/img/about/company4.jpg"
            style="height: 210px; padding: 0 8px" />
        </div>
      </div>
    </div>

    <div
      class="section-company section-bg text-align-center"
      style="height: 650px">
      <div class="w1200 div-txt-center mt-5">
        <h1>愿景使命</h1>
      </div>
      <el-row class="mt-4">
        <el-col :span="12">
          <div class="div-right">
            <h2>愿 景 VISION</h2>
            <p>共建碧水青山,不忘初心,砥砺向前!</p>
            <h2 style="margin-top: 30px">使 命 MISSION</h2>
            <p>◆ 对社会：促进和谐 担当责任</p>
            <p>◆ 对行业：放心产品 贴心服务</p>
            <p>◆ 对员工：享受发展 后顾无忧</p>
            <p>◆ 对股东：放心投资 持续回报</p>
            <p>◆ 对伙伴：相互促进 发展共赢</p>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="div-left">
            <img
              src="@/static/img/about/company5.jpg"
              style="width: 610px; height: 440px" />
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="section-company text-align-center" style="height: 650px">
      <div class="w1200 div-txt-center mt-5">
        <h1>科瑞达精神</h1>
      </div>
      <div class="w1200-2 div-txt-center mt-4">
        <div class="row js-bg">
          <div class="col-lg-6 mt-4"></div>
          <div class="col-lg-6 mt-4">
            <div class="div-list">
              <p>
                ◆
                团结：团结对一个人来说是一种素质，对一个家庭来说是一种幸福，对一个团体来说是一种力量。团结是战胜一切困难的有力武器，是每一个员工应具有的优秀品质，是实现科瑞达宏伟目标的基本保证。
              </p>
              <p>
                ◆
                务实：坚持办实事、讲实话、求实效。实实在在做人，踏踏实实做事。不搞形式主义，坚持求真务实。
              </p>
              <p>
                ◆
                创新：认真打造和完善全员创新体系，积极有效采纳合理化建议。支持奖励技术革新，小改小革。不断创新生产工艺，优化技术指标，改善管理手段，提升管理效率，开拓品种与市场。
              </p>
              <p>
                ◆
                拼搏：三分天注定，七分靠打拼，爱拼才会赢。拼搏是对理想的追求，是为达到目标的一种执着。只有搏击风雨，大地才能春华秋实。只有勇往直前，才能所向披靡。拼搏是科瑞达人进取向上，努力奋斗的精神。
              </p>
              <p>
                ◆
                奉献：科瑞达是我家，建设靠大家。科瑞达与员工休戚相关，荣辱与共，需要共同无私奉献。奉献是人生真正的价值，奉献是科瑞达生存发展的保证。我们要用爱心和责任铸成一道清新飘逸的彩虹，用真情和奉献呵护我们科瑞达健康发展。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <footer-section></footer-section>
  </div>
</template>
<script>
import HeaderSection from "@/components/public/head.vue";
import FooterSection from "@/components/public/footer.vue";

export default {
  components: {
    HeaderSection,
    FooterSection,
  },
  props: {},
  data() {
    return {
      articleId: 0,
      articleDetail: {},
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {
    //添加标题和meta标签
    let arr = [
      "首页",
      "产品中心",
      "解决方案",
      "客户案例",
      "新闻动态",
      "人才招聘",
      "关于我们",
      "联系我们",
    ];
    document.title = "关于我们-河北科瑞达仪器科技股份有限公司";
    let m = document.querySelectorAll("meta");
    const meta = document.createElement("meta");
    meta.name = "keywords";
    for (let i = 0; i < m.length; i++) {
      arr.some((item) => {
        if (item == m[i].content) {
          m[i].remove();
        }
      });
      if (m[i].content == "公司简介") {
        m[i].remove();
      }
    }
    meta.content = "公司简介";
    m[0].after(meta);
    for (let i = 0; i < m.length; i++) {
      if (m[i].content == "河北科瑞达仪器科技股份有限公司") {
        m[i].remove();
      }
    }
  },
  mounted() {},
};
</script>
<style scoped>
#about-index {
  overflow-x: hidden;
}
/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/
#hero-about {
  width: 100%;
  height: 45vh;
  background: url("~@/static/img/banner/about-banner.jpg");
  background-size: cover;
  position: relative;
}

.w1200 {
  width: 100%;
  max-width: 1200px;
  padding: 0 30px;
  margin: 0 auto;
}
.w1200-2 {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.mt-5 {
  margin-top: 50px;
}
.mt-4 {
  margin-top: 50px;
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}
/* ========= */
/*  about-us */
/* ========= */
.location {
  width: 100%;
  box-shadow: -10px -22px 30px 8px rgba(0, 0, 0, 0.5);
}
.location .left-nav {
  float: left;
}
.location .left-nav a {
  display: inline-block;
  line-height: 50px;
  font-size: 16px;
  color: #666;
  text-align: center;
  padding: 0 20px;
}
.location .left-nav a.active {
  background: #276dc1;
  color: #fff;
}
.box-shadow {
  box-shadow: 0px 30px 25px 18px rgba(0, 0, 0, 0.5);
}
.bg-lightWhite {
  background: #fefefe;
}
.text-align-center {
  text-align: center;
}
.padding-tb-30 {
  padding: 30px 0;
}
.padding-lr-30 {
  padding: 30px 0;
}
.section-company {
  width: 100%;
  padding-top: 30px;
  padding-bottom: 0px;
}
.section-company .div-img {
  margin: 30px 0;
  width: 100%;
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
}
.about-content {
  /*float: left;*/
  width: 80%;
  text-align: center;
  line-height: 40px;
  /*padding-right: 43px;*/
}
.section-bg {
  background-color: #f6f9fe;
}
.div-txt-center h1 {
  color: #000;
  font-size: 32px;
  font-weight: 800;
  line-height: 150%;
  text-align: center;
}
.div-txt-center h2 {
  color: #333;
  font-size: 18px;
  line-height: 150%;
  text-align: center;
}
.div-txt-left p {
  text-align: left;
  letter-spacing: 4px;
  font-size: 16px;
  line-height: 40px;
}
.div-left {
  float: left;
  width: 610px;
  height: 380px;
  text-align: center;
}
.div-right {
  float: right;
  width: 530px;
  height: 380px;
  text-align: center;
  padding: 30px;
  background: rgba(203, 230, 249, 1);
  line-height: 40px;
}
.center {
  width: 1200px;
  margin: 0 auto;
}
.div-list {
  float: left;
  width: 100%;
  text-align: left;
  line-height: 40px;
}
.js-bg {
  height: 500px;
  margin: 0 0 0 0;
  background-position: bottom;
  background-image: url("~@/static/img/about/company_content_bg.jpg") !important;
  background-repeat: repeat-x;
}
</style>
